module.exports = __webpack_public_path__ + "static/media/bright-app-phone@2x.ecc1db54.png";